import { ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createDialogButtonsWrapperStyles } from "../helpers/createDialogButtonsWrapperStyles";

interface DialogButtonsWrapperProps {
  children?: ReactNode;
}

export function DialogButtonsWrapper({ children }: DialogButtonsWrapperProps) {
  const classes = createDialogButtonsWrapperStyles(useTheme());

  return <div className={classes.buttonsWrapper}>{children}</div>;
}
